import { Avatar, AVATAR_HEIGHT_32 } from '../../Avatar'
import { FloatingTooltip } from '../../Floating'

import * as styles from './ListItemAvatar.module.css'

function ListItemAvatar({
  avatar,
  avatarClassName = styles.avatar,
  iconTooltip,
  size = AVATAR_HEIGHT_32,
  ...restProps
}) {
  return (
    <FloatingTooltip content={iconTooltip}>
      <Avatar
        {...restProps}
        className={avatarClassName}
        size={size}
        src={avatar}
      />
    </FloatingTooltip>
  )
}

export default ListItemAvatar
